import { Component } from "@angular/core";

@Component({
  templateUrl: "./trends-view.component.html",
})
export class TrendsViewComponent {}
